<script setup lang="ts">
import type { NavigationMenuItem } from '#ui/types';
import ClickfireLogo from '~/assets/clickfire-logo.svg?url';
import ClickfireLogoDark from '~/assets/clickfire-logo-dark.svg?url';
import { useMerchantSlug } from '~/composables/useMerchantSlug';

const { t } = useI18n();

const route = useRoute();
const merchantSlugMaybeStatic = useMerchantSlug(route, true);

const links = computed<NavigationMenuItem[]>(() => ([
	{
		label: t('button.imprint'),
		to: t('link.imprint'),
	},
	{
		label: t('button.privacyPolicy'),
		to: merchantSlugMaybeStatic.value ? { name: 'MerchantContentPage', params: { slug: 'privacy', merchantSlug: merchantSlugMaybeStatic.value } } : t('link.privacyPolicy'),
	},
	{
		label: t('button.tos'),
		to: merchantSlugMaybeStatic.value ? { name: 'MerchantContentPage', params: { slug: 'terms_of_use', merchantSlug: merchantSlugMaybeStatic.value } } : t('link.tos'),
	},
]));
</script>

<template>
	<div class="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl py-8 lg:pb-4 lg:flex lg:items-center lg:justify-between lg:gap-x-3">
		<div class="flex items-center justify-center mb-2 lg:mb-0">
			<p class="text-xs text-dimmed mr-1 italic">
				<!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
				{{ 'powered by' }}
			</p>
			<UColorModeImage
				:light="ClickfireLogo"
				:dark="ClickfireLogoDark"
				alt="Clickfire"
				class="h-6 ml-1 transform -translate-y-1"
			/>
		</div>
		<div class="w-px bg-accented h-full hidden lg:block" />
		<div class="text-sm flex gap-4 text-dimmed font-semibold">
			<NuxtLink
				v-for="link in links"
				:key="link.label"
				:to="link.to"
				class="hover:text-muted"
				target="_blank"
			>
				{{ link.label }}
			</NuxtLink>
		</div>
	</div>
</template>
